import * as React from 'react';
import SelectField from '../SelectField';
import { IAddressFormProps } from './interfaces';
import { ISelectOption } from '@pinpointhq/thumbtack';

export function UsAddressForm({
  fieldNames,
  stateOptions,
  attributes,
  handleChange,
  translations,
  required,
}: IAddressFormProps) {
  const handleStateSelect = (selectedOption: ISelectOption | null) => {
    if (selectedOption) {
      const syntheticEvent = {
        target: {
          value: selectedOption.value // This will be the state abbreviation (e.g., "OH")
        },
        persist: () => {}
      } as React.ChangeEvent<HTMLInputElement>;

      handleChange(syntheticEvent, 'town');
    }
  };

  return (
    <>
      <div className="col-1-1">
        <label className="external-form__label external-form__label--required">{translations.streetAddress}</label>
        <input
          type="text"
          name={fieldNames.addressOne}
          id="address1"
          required={required}
          placeholder={translations.streetAddressPlaceholder}
          value={attributes.addressOne || ''}
          onChange={(e) => handleChange(e, 'addressOne')}
        />
      </div>
      <div className="col-1-1">
        <label className="external-form__label external-form__label--required">{translations.city}</label>
        <input
          type="text"
          name={fieldNames.addressTwo}
          id="address2"
          required={required}
          placeholder={translations.cityPlaceholder}
          value={attributes.addressTwo || ''}
          onChange={(e) => handleChange(e, 'addressTwo')}
        />
      </div>
      <div className="col-1-1">
        <label className="external-form__label external-form__label--required">{translations.state}</label>
        <SelectField
          name={fieldNames.town}
          options={stateOptions}
          storedOption={stateOptions.find(option => option.label === attributes.town)?.value || attributes.town}
          handleSelect={handleStateSelect}
          placeholder={translations.statePlaceholder}
        />
      </div>
      <div className="col-1-1">
        <label className="external-form__label external-form__label--required">{translations.zipcode}</label>
        <input
          type="text"
          name={fieldNames.postcode}
          id="postcode"
          required={required}
          placeholder={translations.zipcodePlaceholder}
          value={attributes.postcode || ''}
          onChange={(e) => handleChange(e, 'postcode')}
        />
      </div>
    </>
  );
}
